import React, { forwardRef, useMemo } from "react";
import _, { omit } from "lodash";
import { Form, Typography } from "antd";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes, nameRegexValidator } from "utils/formUtils";
import message from "components/CustomMessage";
import BaseModalForm from "components/BaseModalForm";
import { duplicateNameValidator } from "utils/validatorUtil";


const MobbSecurityConfigForm = forwardRef( ({afterClose, configData, onUpdateConfigComponent, ...props}, ref) => {
    const [form] = Form.useForm();
    const {configList} = props;
    const isEdit = !_.isUndefined(configData);

    const submitData = async (data) => {
        let payload = data;
        payload = omit({
          ...payload,
          configType: "MOBB_SECURITY",
          config:{
              authToken: payload.authToken,
          }
        }, ["authToken"]);

        if(isEdit) {
            const dataToSend = { ...payload, id: configData.id};
            await ToolsIntegrationsAPI.updateGenericConfigDetails(dataToSend).promise;
            message.success(`Successfully updated.`);
          } else {
            await ToolsIntegrationsAPI.postGenericLoginDetails(payload).promise;
            message.success(`Successfully configured.`);
        }
        onUpdateConfigComponent && onUpdateConfigComponent(true);

      };


    const baseModalProps = {
        okText: "Configure",
    }

    
    const fields = useMemo(() => [
        {
            name: "name",
            label: "Name",
            props: {
                autoFocus: true
            },
            colSpan: 24,
            required: true,
            disabled: isEdit, 
            rules: [
                nameRegexValidator,
                duplicateNameValidator({ list: configList }),
            ],
        },
        {
            name: "authToken",
            label: "Token" ,
            type: FieldTypes.PASSWORD,
            help: "Enter a valid token or Generate it",
            labelAlign: "left",
            colSpan: 24,
            required: true,
        },
        {
            name: "generateTokenNote",
            colSpan: 24,
            render: () => (
                <Typography.Text underline>
                    <a href="https://app.mobb.ai/" target="_blank" rel="noopener noreferrer">
                        Generate Token
                    </a>
                </Typography.Text>
            ),
        }

    ], [configList, isEdit])


    return (
        <BaseModalForm             
            modalProps={baseModalProps}
            ref={ref}
            form={form} 
            fields={fields}
            onOk={submitData}
            afterClose={afterClose}
            title= {`Configure ${_.replace(props?.id, "_", " ")}`}
            initialValues={ { baseUrl: isEdit ? configData.hostUrl: "" , name: configData?.name} }
        >
        </BaseModalForm>
    )
})

export default MobbSecurityConfigForm
